export const formatNumber = (number: number) => {
  if (!number) return '0';
  if (number >= 1_000_000) {
    return `${(number / 1_000_000).toFixed(0)}M`;
  }
  if (number >= 1_000) {
    return `${(number / 1_000).toFixed(0)}K`;
  }
  return number.toString();
};
